import { SITE } from "../lib/site";

/**
 * Logo Termite Bordeaux (visuel TH33 fourni par le client).
 */
export default function Logo({ className = "", inverted = false, size = "default", textVisible = true }) {
  const dims = { sm: 36, default: 44, lg: 56 }[size] || 44;
  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src="/brand/logo.png"
        alt="Logo Termite Bordeaux — expert traitement termites Gironde"
        width={dims}
        height={dims}
        className="shrink-0 object-contain"
        style={{ width: dims, height: dims }}
      />
      {textVisible && (
        <div className="leading-tight">
          <div className={`font-serif text-xl font-semibold ${inverted ? "text-white" : "text-gray-900"}`}>
            {SITE.displayBrand}
          </div>
          <div className={`text-[10px] tracking-[0.2em] uppercase ${inverted ? "text-white/70" : "text-gray-500"}`}>
            {SITE.brandTagline}
          </div>
        </div>
      )}
    </div>
  );
}
